const CourseColors = [
  "#397962",
  "#b74942",
  "#be591c",
  "#7f6378",
  "#59736a",
  "#0d5ac1",
  "#c004b7",
  "#1c0365",
  "#0f7c7f",
  "#076fd8",
  "#517911",
  "#af48cc",
  "#6119d0",
  "#c64c59",
  "#86722a",
  "#c2410a",
  "#651be6",
  "#6c7262",
  "#20811e",
  "#cd2f00",
  "#9348af",
  "#01793b",
  "#8742f7",
  "#996635",
  "#b11573",
  "#357e51",
  "#227846",
  "#2f3f94",
  "#2f7b99",
  "#bc5935",
  "#2c741a",
  "#567c25",
  "#ca4751",
  "#7e50a8",
  "#616c18",
  "#5c721b",
  "#0a7f6f",
  "#22810f",
  "#566ca0",
  "#2f1179",
  "#935b6d",
  "#513d98",
  "#757427",
  "#916064",
  "#4b5bdc",
  "#07723b",
  "#250662",
  "#b31cdc",
  "#228916",
  "#ac3e1b",
  "#d12d25",
  "#417376",
  "#880977",
  "#e1136e",
  "#8c51ad",
  "#527e7f",
  "#737119",
  "#5d2c52",
  "#2d7111",
  "#726711",
  "#217d8e",
  "#4b7127",
  "#b74e7e",
  "#596807",
  "#077897",
  "#d11293",
  "#d122a5",
  "#c71fb3",
  "#038849",
  "#5426e0",
  "#4834d0",
  "#802234",
  "#6749e8",
  "#0971f0",
  "#586f0c",
  "#6c7240",
  "#806a24",
  "#1d762b",
  "#cc047b",
  "#2379a1",
  "#3c761e",
  "#21538e",
  "#477218",
  "#ba4c2d",
  "#4e6e0a",
  "#0023b8",
  "#337824",
  "#986b53",
  "#dc041f",
  "#983f7a",
  "#c81387",
  "#79352c",
  "#521250",
  "#9f58b2",
  "#747c27",
  "#e0283e",
  "#646c2a",
  "#117361",
  "#6b2e5f",
  "#526b0c",
  "#21538e",
  "#477218",
  "#ba4c2d",
  "#4e6e0a",
  "#0023b8",
  "#337824",
  "#986b53",
  "#dc041f",
  "#983f7a",
  "#c81387",
  "#79352c",
  "#521250",
  "#747c27",
  "#e0283e",
  "#646c2a",
  "#c904be",
  "#117361",
  "#6b2e5f",
  "#526b0c",
  "#5e6e2c",
  "#996c48",
  "#577d7a",
  "#037d2e",
  "#a65325",
  "#0a8718",
  "#d80358",
  "#667e0c",
  "#aa226d",
  "#792ed8",
  "#627424",
  "#520d3a",
  "#2c7d05",
  "#4c67b3",
  "#7d1d85",
  "#486d01",
  "#986c09",
  "#4b7c11",
  "#ce4611",
  "#243eeb",
  "#b616fb",
  "#377364",
  "#421f79",
  "#7a3d93",
  "#635f6d",
  "#9b5c2a",
  "#0b7192",
  "#0f5997",
  "#387f77",
  "#911e20",
  "#1350ce",
  "#098667",
  "#cb2582",
  "#ce00be",
  "#177172",
  "#557665",
  "#a15a99",
  "#00783c",
  "#77772a",
  "#446f93",
  "#d01c04",
  "#ad540b",
  "#358028",
  "#060e27",
  "#21751c",
  "#137d1b",
  "#d00043",
  "#ab6252",
  "#14801a",
  "#4f0f6f",
  "#1d1d58",
  "#947002",
  "#566c13",
  "#b05820",
  "#017171",
  "#36486a",
  "#d02e29",
  "#0d746e",
  "#3e464c",
  "#a84a8f",
  "#911e7e",
  "#3f16d9",
  "#0f525f",
  "#946b09",
  "#66723b",
  "#6a7116",
  "#1d792b",
  "#3d6751",
  "#c93d02",
  "#640fc1",
  "#3b7325",
  "#c73c2c",
  "#627a08",
  "#275af8",
  "#615af0",
  "#2a3434",
  "#4a543f",
  "#3c7960",
  "#5473a9",
  "#006f63",
  "#4a841e",
  "#7260d8",
  "#0c7c57",
  "#03771c",
  "#823c59",
  "#6c6611",
  "#dc1c06",
  "#e11d0b",
  "#a15732",
  "#007974",
  "#a82b89",
  "#1a8011",
  "#436a9f",
  "#1a806a",
  "#0b7f44",
  "#a6567b",
  "#20760d",
  "#b308d3",
  "#bb3f03",
  "#af3101",
  "#1170d5",
  "#09780d",
  "#cd1fba",
  "#ce335d",
  "#007979",
  "#474893",
  "#107c0c",
  "#1c65cb",
  "#5d1d0c",
  "#2d7d2a",
  "#d21300",
  "#1c843e",
  "#a259a4",
  "#936715",
  "#0a7e7b",
  "#60727f",
  "#a75e0c",
  "#626c25",
  "#be2d98",
  "#d70a9c",
  "#167645",
  "#7a53c0",
  "#15741e",
  "#8253d2",
  "#1a806b",
  "#436a9e",
  "#007ba7",
  "#d10694",
  "#9b5bba",
  "#8d6c2f",
  "#d3277a",
  "#227b85",
  "#7059e4",
  "#5768ad",
  "#b43dcb",
  "#337c02",
  "#4c7385",
  "#057858",
  "#048093",
  "#606913",
  "#138463",
];

export default CourseColors;
